import type { ReactElement } from 'react';

interface ItemErrorTextProps {
  messages: (string | undefined)[];
}

export const ItemErrorText = ({ messages }: ItemErrorTextProps): ReactElement | null => {
  const visible = messages.filter((m): m is string => Boolean(m));
  if (visible.length === 0) return null;

  return (
    <div className="vtwo:mt-1 vtwo:pl-6 vtwo:flex vtwo:flex-col vtwo:gap-0.5">
      {visible.map((message) => (
        <p key={message} className="vtwo:text-xs vtwo:text-red-500 vtwo:m-0">
          {message}
        </p>
      ))}
    </div>
  );
};
